import { ModeOfTransport } from 'types/supplyChain.types';
export const MAP_TRANSPORT_TRANSLATION_KEYS = {
    [ModeOfTransport.TRUCK]: 'mode-of-transport.by-truck',
    [ModeOfTransport.TRAIN]: 'mode-of-transport.by-train',
    [ModeOfTransport.AIRPLANE]: 'mode-of-transport.by-airplane',
    [ModeOfTransport.SHIP]: 'mode-of-transport.by-ship',
    [ModeOfTransport.WALKING_AND_MOTORBIKE]: 'mode-of-transport.by-walking-and-motorbike',
    [ModeOfTransport.OTHER]: 'mode-of-transport.other',
};
export const MAP_TRANSPORT_ICONS = {
    [ModeOfTransport.TRUCK]: {
        url: `${process.env.NEXT_PUBLIC_DEPLOY_URL}/transport/truck.svg`,
        width: 95,
        height: 68,
    },
    [ModeOfTransport.TRAIN]: {
        url: `${process.env.NEXT_PUBLIC_DEPLOY_URL}/transport/train.svg`,
        width: 110,
        height: 66,
        x: 0,
        y: 0,
    },
    [ModeOfTransport.AIRPLANE]: {
        url: `${process.env.NEXT_PUBLIC_DEPLOY_URL}/transport/plane.svg`,
        width: 117,
        height: 83,
    },
    [ModeOfTransport.SHIP]: {
        url: `${process.env.NEXT_PUBLIC_DEPLOY_URL}/transport/ship.svg`,
        width: 109,
        height: 72,
    },
    [ModeOfTransport.WALKING_AND_MOTORBIKE]: {
        url: `${process.env.NEXT_PUBLIC_DEPLOY_URL}/transport/walking-and-motorbike.svg`,
        width: 95,
        height: 95,
    },
    [ModeOfTransport.OTHER]: undefined,
};
